// Weather Live module — five major Australian cities with icons + temperatures.
import { useEffect, useState } from "react";
import { Sun, CloudSun, Cloud, CloudRain, CloudDrizzle, Wind } from "lucide-react";

const CITIES = [
  { k: "Sydney",    t: 22, icon: Sun,        note: "Sunny",         hi: 24, lo: 16, tint: "#F5C24A" },
  { k: "Melbourne", t: 16, icon: CloudRain,  note: "Light rain",    hi: 18, lo: 12, tint: "#6B93D6" },
  { k: "Brisbane",  t: 27, icon: CloudSun,   note: "Part cloud",    hi: 29, lo: 20, tint: "#F5A94A" },
  { k: "Perth",     t: 30, icon: Sun,        note: "Clear",         hi: 32, lo: 21, tint: "#F26B4E" },
  { k: "Adelaide",  t: 24, icon: Cloud,      note: "Overcast",      hi: 26, lo: 17, tint: "#9AA5B3" },
];

export default function WeatherModule() {
  const [stamp, setStamp] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setStamp(s => s + 1), 60_000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="border-y" style={{borderColor:"var(--line)", borderTopWidth:3, borderBottomWidth:3}} data-testid="weather-module">
      <div className="flex items-baseline justify-between py-3">
        <h3 className="font-display text-2xl">Weather</h3>
        <span className="font-cond text-[10px] tracking-[0.18em] flex items-center gap-1.5" style={{color:"var(--fg-mute)"}}>
          <span className="live-dot"/>LIVE
        </span>
      </div>
      <ul>
        {CITIES.map((c) => {
          const Icon = c.icon;
          return (
            <li key={c.k} className="grid grid-cols-12 items-center gap-2 py-3 border-t" style={{borderColor:"var(--line-soft)"}}>
              <span className="col-span-5 font-display text-[14px]">{c.k}</span>
              <span className="col-span-2 flex justify-center" style={{color: c.tint}}>
                <Icon size={20} strokeWidth={1.5}/>
              </span>
              <span className="col-span-3 text-right font-mono text-[15px] tabular-nums font-semibold">{c.t}°</span>
              <span className="col-span-2 text-right font-mono text-[10px] tabular-nums" style={{color:"var(--fg-mute)"}}>
                {c.hi}°/{c.lo}°
              </span>
              <span className="col-span-12 text-[10.5px] font-cond tracking-wider pl-1" style={{color:"var(--fg-mute)"}}>
                {c.note.toUpperCase()}
              </span>
            </li>
          );
        })}
      </ul>
      <p className="font-mono text-[10px] py-2.5 border-t flex items-center justify-between" style={{borderColor:"var(--line-soft)", color:"var(--fg-mute)"}}>
        <span>Updated {stamp === 0 ? "just now" : `${stamp} min ago`}</span>
        <span>· source: BOM</span>
      </p>
    </div>
  );
}
